import { render } from "./RefTicket.vue?vue&type=template&id=5befbe98"
import script from "./RefTicket.vue?vue&type=script&lang=js"
export * from "./RefTicket.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__